var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
const _RicosNodeStyle = class _RicosNodeStyle {
  constructor(nodeStyle) {
    __publicField(this, "nodeStyle");
    __publicField(this, "getNodeStyle", () => this.nodeStyle);
    __publicField(this, "toCustomStyle", () => {
      return { paddingBottom: this.nodeStyle.paddingBottom, paddingTop: this.nodeStyle.paddingTop };
    });
    __publicField(this, "overrideWith", (NodeStyle = {}) => {
      return _RicosNodeStyle.of({ ...this.nodeStyle, ...NodeStyle });
    });
    this.nodeStyle = nodeStyle;
  }
  static of(nodeStyle) {
    return new _RicosNodeStyle(nodeStyle || {});
  }
};
__publicField(_RicosNodeStyle, "fromCustomStyle", (customStyle) => {
  const { paddingBottom, paddingTop } = customStyle;
  const nodeStyle = {
    paddingBottom,
    paddingTop
  };
  return _RicosNodeStyle.of(nodeStyle);
});
let RicosNodeStyle = _RicosNodeStyle;
export {
  RicosNodeStyle
};
//# sourceMappingURL=node-style.js.map
